// MessageMeta.js
import { connect } from 'react-redux';
import MessageMeta from '../component/MessageMeta.jsx';

import getMessageData from '../selector/getMessageData.js';

const mapStateToProps = (state, { id }) => {
  const viewCount = getMessageData(state, id, 'viewCountWithDefault');
  return {
    likes: getMessageData(state, id, 'likes'),
    dislikes: getMessageData(state, id, 'dislikes'),
    viewCount,
    likePercentage: getMessageData(state, id, 'likePercentage'),
    likePercentageWithSignOrDefault: getMessageData(
      state,
      id,
      'likePercentageWithSignOrDefault'
    ),
    expiresAtUnix: getMessageData(state, id, 'expiresAtUnix'),
    unlockCount: getMessageData(state, id, 'unlocksWithDefault'),
  };
};

export default connect(mapStateToProps)(MessageMeta);
